/* Global imports */
import React, { useState } from 'react'
import { string } from 'prop-types'
import { Button, Grid, Segment } from 'semantic-ui-react'

/* Local imports */
import { createProfessional } from 'Services/professional'
import { resetPassword } from 'Services/user'
import Text from 'Components/Text'
import fields from 'Screens/ProfessionalEditor/fields'
import { initialState, renderField } from 'Screens/ProfessionalEditor'

/* Component definition */
const ProfessionalCreator = ({ id, onSuccess }) => {
  const [loading, setLoading] = useState(false)
  const [professional, setProfessional] = useState(initialState)

  const onFieldChange = (key, valueKey = 'value') => (e, { [valueKey]: value }) => {
    setProfessional({
      ...professional,
      [key]: value,
    })
  }


  const onSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    const onError = (error) => {
      console.error(error)
    }

    createProfessional(professional)
      .then(p => {
        // Send password reset email after professional is created
        // We need to wait for the Firebase function to create the auth user
        if (professional.email) {
          const sendPasswordResetWithRetry = (email, retries = 5, delay = 2000) => {
            resetPassword(email)
              .then(() => {
                console.log('Password reset email sent successfully')
              })
              .catch(error => {
                if (error.code === 'auth/user-not-found' && retries > 0) {
                  console.log(`Auth user not ready yet, retrying in ${delay}ms... (${retries} retries left)`)
                  setTimeout(() => {
                    sendPasswordResetWithRetry(email, retries - 1, delay)
                  }, delay)
                } else {
                  console.error('Error sending password reset email:', error)
                }
              })
          }
          
          // Start trying to send password reset after a short delay
          setTimeout(() => {
            sendPasswordResetWithRetry(professional.email)
          }, 2000)
        }
        
        setLoading(false)
        return p
      })
      .then(onSuccess)
      .catch(onError)
  }
  return (
    <form onSubmit={onSubmit}>
      <Segment textAlign="center">
        <Text as="h1">professional.creator.title</Text>
        <Grid columns={3}>
          {
            fields.map(renderField(loading, onFieldChange, professional))
          }
          <Grid.Row>
            <Grid.Column textAlign="center" width={16}>
              <Button
                primary
                type="submit">
                  {<Text>professional.creator.save</Text>}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </form>
  )
}

/* PropTypes */
ProfessionalCreator.propTypes = {
  id: string,
}

ProfessionalCreator.defaultProps = {}

/* Local utility functions */

/* Local Styled Components */

export default ProfessionalCreator
